/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAddAdditionalInfo, ILliCheckoutAdditionalInfoViewProps, IShowAdditionalInfo } from './lli-checkout-additional-info';

export const ShowAdditionalInfo: React.FC<IShowAdditionalInfo> = ({ showInfoProps, orderReference, orderNotes, requestedShippingDate, editButton }) => (
    <Node {...showInfoProps}>
        {orderReference}
        {orderNotes}
        {requestedShippingDate}
        {editButton}
    </Node>
);

export const AddAdditionalInfo: React.FC<IAddAdditionalInfo> = ({
    addFormProps,
    submitButton,
    cancelButton,
    inputGroupProps,
    orderReferenceProps,
    orderNotesProps,
    requestedShippingDateProps,
    error
}) => (
    <Node {...addFormProps}>
        <Node {...inputGroupProps}>
            {error}
            {orderReferenceProps.label}
            {orderReferenceProps.input}
            {orderNotesProps.label}
            {orderNotesProps.input}
            {requestedShippingDateProps.label}
            {requestedShippingDateProps.input}
        </Node>
        {submitButton}
        {cancelButton}
    </Node>
);

const LliCheckoutAdditionalInfoView: React.FC<ILliCheckoutAdditionalInfoViewProps> = ({ moduleProps, showAdditionalInfo, addAdditionalInfo }) => {
    return (
        <Module {...moduleProps}>
            {showAdditionalInfo && <ShowAdditionalInfo {...showAdditionalInfo} />}
            {addAdditionalInfo && <AddAdditionalInfo {...addAdditionalInfo} />}
        </Module>
    );
};

export default LliCheckoutAdditionalInfoView;
